import "../../style/common/footer.scss";

const Footer = (props) => {

    return (
        <footer className="grow-biz">
            <div className="container grid-xxl mt-4">
                <div className="columns">
                    <div className="column col-xl-12 col-6 mb-4">
                        <div className="center-lg">
                            <img src="https://unbxd.github.io/static/4080d3c1740864193f74e415383f93bb/8eabc/grow-business.webp" alt="Grow your business"></img>
                        </div>
                    </div>
                    <div className="column col-xl-12 col-6">
                        <div className="columns justify-center">
                            <div className="column col-sm-12 col-6 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-title ">Schedule a Demo</div>
                                    </div>
                                    <div className="card-body">Know how Unbxd can help you uplift on-site conversions</div>
                                    <div className="card-footer">
                                        <a className="footer-text" target="_blank" href="https://unbxd.com/demo/">Book a slot &nbsp; <span className="white-right-chevron"></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default Footer;
